import { Component } from '../core/component.js';
import { MapUtils } from '../../utility/map-utils.js';
import {
  DataModelBuilder,
  isSameData,
  SerializationContext,
  SerializedData,
} from '../../models/dto/dto.js';
import { CurrencySettings } from '../../models/serializable/currency-settings.js';

export class CurrencySettingsComponent extends Component {
  static readonly TYPE_ID: string = '9927a278f37d4f53b5987998d16b3e6c';

  constructor(
    public readonly settings: CurrencySettings,
  ) {
    super();
  }

  get $typeId() {
    return CurrencySettingsComponent.TYPE_ID;
  }

  get $removable() {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): CurrencySettingsComponent {
    return new CurrencySettingsComponent(
        context.fromData(MapUtils.get<SerializedData>(map, 'settings')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'settings': context.toData(this.settings),
    };
  }

  clone(): this {
    return new CurrencySettingsComponent(
        this.settings.clone(),
    ) as this;
  }

  isSame(other: CurrencySettingsComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.settings, this.settings);
  }
}

export class CurrencySettingsComponentBuilder extends DataModelBuilder<CurrencySettingsComponent> {
  build(context: SerializationContext, map: SerializedData): CurrencySettingsComponent {
    return CurrencySettingsComponent.fromMap(context, map);
  }
}
